import env from 'shared/store/env'
import { wsMessageType } from './types'

const websocketUrl: string = process.env.REACT_APP_WEBSOCKET || env.websocketUrl

/** Singleton */
let socket: any
let handleMessage = (message: any) => null
let retry: number = 0
let deviceId: ?string = undefined
let token: ?string = undefined
let application: ?string = undefined
let platform: ?string = undefined

const MAX_RETRY = 5

/** We need redux store in order to dispatch action on message */
type WebSocketConfig = {|
    handleMessage: (message: any) => void,
    deviceId?: string,
    token?: string,
    application?: string,
    platform?: string
|}
const setupWebsocket = (config: WebSocketConfig) => {
    handleMessage = config.handleMessage
    deviceId = config.deviceId
    token = config.token
    application = config.application
    platform = config.platform
}

/** Create websocket and setup callbacks on message */
const initWebsocket = () => {
    socket = new WebSocket(websocketUrl)

    socket.onopen = () => {
        retry = 0
        /** On open -> link websocket with deviceId */
        socket.send(
            JSON.stringify({
                type: wsMessageType.IDENTIFICATION,
                deviceId,
                token,
                application,
                platform
            })
        )
    }

    socket.onmessage = (e: any) => {
        handleMessage(e)
    }

    socket.onclose = (e: any) => {
        /** If connexion closed try to reconnect */
        retry = retry + 1
        if (retry < MAX_RETRY) {
            setTimeout(initWebsocket, 5000)
        }
    }

    socket.onerror = (e: any) => {
        console.log('Socket error: ')
        console.error(e.message)
        socket.close()
    }
    return socket
}

/** Singleton */
const getWebsocket = () => {
    /** Initialize websocket only if needed */
    if (!socket) {
        initWebsocket()
    }
    return socket
}

const sendToken = (userToken?: string) => {
    /** Initialize websocket only if needed */
    token = userToken ? userToken : null
    if (socket) {
        /** We want to update Websocket with the user token provived **/
        retry = 0
        socket.send(
            JSON.stringify({
                type: wsMessageType.IDENTIFICATION,
                token: userToken
            })
        )
    }
}

const closeWebsocket = () => {
    /** Avoid reconnexion */
    retry = MAX_RETRY
    /** If connected, close connexion */
    token = undefined
    if (socket) {
        socket.close()
    }
    /** Allow a new connexion */
    socket = null
    return true
}

export { setupWebsocket, closeWebsocket, getWebsocket, sendToken }
